export const headerHeight = 48;
export const megaMenuHeaderHeight = 110;
export const footerHeight = 32;

export const drawerTabWidth = 115;
export const searchHeaderHeight = 50;
export const searchInputHeight = 32;

export const sidebarWidth = 64;
export const sidebarMobileHeight = 35;
export const smallSidebarDrawerWidth = 250;
export const accountSidebarWidth = 280;
export const sidebarDrawerWidth = 360;
export const sidebarToggleHeight = 38;
export const binderTabDrawerWidth = 291;

export const searchDownloadWidth = 48;
export const searchExpandWidth = 32;
export const searchSelectWidth = 32;
export const searchResultsHeaderHeight = 34;

export const criterionEditorDesktopSpacing = 30;
export const criterionEditorMobileSpacing = 16;

export const inputHeaderHeight = 26;

export const binderPrintWidth = 1025;

export const binderBarIconWidth = 20;
export const binderBarIconPadding = 2;
export const binderBarIconFullWidth = binderBarIconWidth + 2 * binderBarIconPadding;
export const binderBarShareAvatarWidth = 22;
export const binderBarShareFullWidth = binderBarShareAvatarWidth + 2 * binderBarIconPadding;

export const accountPaddingHorizontal = 17;
